import { render, staticRenderFns } from "./animateNumber.vue?vue&type=template&id=06e3fb7a"
import script from "./animateNumber.vue?vue&type=script&lang=js"
export * from "./animateNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports